module.exports = __webpack_public_path__ + "img/screen-delay.de859347.png";